<div class="ui-dialog-content" style="padding: 0;">
  <div class="ui-g-12" *ngIf="!planningDate">
    <div class="ui-g-12 ui-md-4">
      <p>{{ 'customerSetBuilder.setName' | translate }}</p>
      <input pInputText type="text" [(ngModel)]="setCode">
    </div>
    <div class="ui-g-12 ui-md-8">
      <p>{{ 'customerSetBuilder.setDescription' | translate }}</p>
      <input pInputText type="text" [(ngModel)]="setDescription">
    </div>
  </div>
  <div class="ui-g-12" *ngIf="!planningDate">
    <div class="ui-g-12 ui-md-2">
      <p *ngIf="enabled">{{ 'campaign.active' | translate }}</p>
      <p *ngIf="!enabled">{{ 'common.status_inattive' | translate }}</p>
      <div class="ui-g-12 ui-md-3" style="padding-left: 0;">
        <p-inputSwitch [(ngModel)]="enabled"></p-inputSwitch>
      </div>
    </div>
    <div class="ui-g-12 ui-md-4">
      <p>{{ 'customerSetBuilder.deleteCustomerNotPresentInCluster' | translate }}</p>
      <div class="ui-g-12 ui-md-3" style="padding-left: 0;">
        <p-inputSwitch [(ngModel)]="enabledDeleteCustomer"></p-inputSwitch>
      </div>
    </div>
    <div class="ui-g-12 ui-md-6">
      <p>{{ 'customerSetBuilder.populateCluster' | translate }}</p>
      <div class="ui-g-12 ui-md-3" style="padding-left: 0;">
        <p-inputSwitch [(ngModel)]="flgCreate"></p-inputSwitch>
      </div>
      <div class="ui-g-12 ui-md-9" style="padding-right: 0;">
        <p-dropdown
          id="cluster-head-select"
          [options]="clusterHeadList"
          [(ngModel)]="selectedClusterHead"
          [style]="{'width':'100%'}"
          [disabled]="!flgCreate"
          [filter]="true"
        >
        </p-dropdown>
      </div>
    </div>
  </div>
  <!-- Cron Jobs -->
  <div class="ui-g-12" style="margin-bottom: 20px;" *ngIf="planningDate || saveQuery">
    <div class="ui-g-12 ui-md-8">
      <!-- Esecuzione Singola -->
      <p-radioButton class="cron-jobs-radio" name="cron-jobs" value="single" [(ngModel)]="executionType" label="{{'customerSetBuilder.singleExecution' | translate}}"></p-radioButton>
      <div *ngIf="executionType === 'single'" class="cron-container">
        <p-calendar
          [dateFormat]="calendarTranslateService.pcalendarTranslate.dateFormat"
          [locale]="calendarTranslateService.pcalendarTranslate"
          showIcon="true"
          inputName="cronDateField"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="'1900:2099'"
          [(ngModel)]="singleExecDate"
          [placeholder]="calendarTranslateService.pcalendarTranslate.dateFormat"
          [inputStyle]="{'height':'32px'}"
          readonlyInput="true">
        </p-calendar>
      </div>
    </div>
    <div class="ui-g-12">
      <!-- Esecuzione Ricorrente -->
      <p-radioButton (onClick)="cambioLabel()" class="cron-jobs-radio" name="cron-jobs" value="recurring" [(ngModel)]="executionType" label="{{'customerSetBuilder.recurringExecution' | translate}}"></p-radioButton>
      <div *ngIf="executionType === 'recurring'" class="cron-container">
        <cron-jobs [(ngModel)]="cronJobsFrequency" [config]="cronJobsConfig"></cron-jobs>
          <form [formGroup]="cronJobsForm">
            <div class="ui-g-12 ui-md-6" style="padding-left: 0;">
              <app-kv-calendar
                #dateStartField
                [inputName]="'dateStart'"
                [formData]="cronJobsForm"
                [defaultDate]="setDefaultDateStart()"
                [defaultValue]="setDefaultDateStart()"
                [startDateSelector]="true"
                [endDateInputName]="'dateEnd'"
                [endDateCalendar]="dateEndField"
              ></app-kv-calendar>
            </div>
            <div class="ui-g-12 ui-md-6">
              <app-kv-calendar
                #dateEndField
                [inputName]="'dateEnd'"
                [formData]="cronJobsForm"
                [defaultDate]="setDefaultDateEnd()"
                [defaultValue]="setDefaultDateEnd()"
                [endDateSelector]="true"
                [startDateInputName]="'dateStart'"
                [startDateCalendar]="dateStartField"
              ></app-kv-calendar>
            </div>
          </form>
      </div>
    </div>
  </div>
</div>
<div class="ui-dialog-footer">
  <button
    type="button"
    pButton
    class="ui-button-success btnDelete"
    icon="fa fa-floppy-o"
    (click)="saveSet()"
    label="{{ 'customerSetBuilder.saveSet' | translate }}"
    [disabled]="
      !setCode ||
      !setDescription ||
      (executionType === 'single' && !singleExecDate) ||
      (executionType === 'recurring' && (!cronJobsFrequency || !cronJobsForm.controls.dateStart.value || !cronJobsForm.controls.dateEnd.value)) ||
      (flgCreate && !selectedClusterHead)
    ">
  </button>
  <button
    type="button"
    pButton
    class="ui-button-danger btnDelete"
    icon="fa fa-close"
    (click)="onCloseDialog.emit()"
    label="{{ 'common.cancel' | translate }}">
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-builder/customer-set-save/customer-set-save.component.html